const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

export default function CtaSection() {
  const scrollToContact = () => {
    const el = document.getElementById("contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20urban%20skyline%20city%20buildings%20architecture%20aerial%20view%20blue%20hour%20night%20cityscape%20impressive%20structures%20professional%20photography%20beautiful%20lighting%20metropolitan%20area%20contemporary%20design&width=1920&height=600&seq=cta1&orientation=landscape"
          alt="CTA background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, #1E3A8A/95 0%, #121212/90 100%)", backgroundColor: "rgba(30,58,138,0.92)" }} />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <span className="text-[#C9A24A] text-xs font-semibold tracking-widest uppercase mb-4 block">
          Pronto para começar?
        </span>
        <h2 className="text-white font-bold text-4xl md:text-5xl mb-4 leading-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
          Transforme seu projeto em realidade<br />
          com <span style={{ color: "#C9A24A" }}>segurança e qualidade.</span>
        </h2>
        <p className="text-white/80 text-lg mb-10 max-w-xl mx-auto">
          Entre em contato agora e descubra como a Construlife pode ajudar você a construir com confiança.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#1E3A8A] font-semibold px-8 py-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line" />
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
